import { LOANS } from 'loans.module/common/domain/constants.loans';
class ModalDetailAdhesionController {

  constructor($window,myLoansService, LoansUserDataService) {
    'ngInject';
    this.isMobileApp = $window.innerWidth < 1024;
    this.myLoansService = myLoansService;
    this.loansUserDataService = LoansUserDataService;
    this.userId = this.loansUserDataService._employee.userId;
    this.showModalSucess=false;
  }

  $onInit() {
    if(this.isMobileApp)
      this.floatingActionButtons = this.getFloatingActionButtons();
  }

  dismiss() {
    angular.element('.modal').modal('hide');
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.CLOSE'
      }
    ];
  }

  showCancellationDate() {
    return this.loan.statusCode === LOANS.STATES.ID.NOT_IN_FORCE;
  }
  showRequestNovation(){
    return this.loan.novationCollective || this.loan.novationTypeVariable;
  }

  sendRequestNovation(){
    this.myLoansService.sendRequestNovation(this.userId, this.loan);
    this.loan.novationCollective = false;
    this.loan.novationTypeVariable = false;
    this.showModalSucess = true;
  }

  isSuccess(){
    return this.showModalSucess;
  }

  removeSuccessfulModal() {
    this.showModalSucess = false;
  }
}

export default ModalDetailAdhesionController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/modalDetailAdhesion/modalDetailAdhesion.controller.js